module.exports = __webpack_public_path__ + "68c3f34dd621854f806ae903cd348ede.png";